import { useDxModal } from '@repo/vue/utils';
import { DxModal } from '@repo/vue/components';

export const useDxConfirm = () => {
  const dxModal = useDxModal();

  const show = (
    type?: string,
    header?: string,
    message?: string,
    btnOk?: string,
    btnCancel?: string,
    size?: string,
    helpRoute?: string
  ): Promise<any> => {
    const modalProps = {
      size: size || 'md',
      backdrop: 'static',
      class: 'dialog-sm',
      type: type,
      header: header,
      html: message,
      btnOk: btnOk,
      btnCancel: btnCancel,
      helpRoute: helpRoute
    };
    return dxModal.prompt(DxModal, modalProps);
  };

  const information = (
    header?: string,
    message?: string,
    btnOk?: string,
    btnCancel?: string,
    size?: string,
    helpRoute?: string
  ) => {
    return show('info', header, message, btnOk, btnCancel, size, helpRoute);
  };

  const warning = (
    header?: string,
    message?: string,
    btnOk?: string,
    btnCancel?: string,
    size?: string,
    helpRoute?: string
  ) => {
    return show('warning', header, message, btnOk, btnCancel, size, helpRoute);
  };

  const custom = (
    title?: string,
    message?: string,
    btnOk?: string,
    btnCancel?: string,
    options?: any,
    size?: string,
    helpRoute?: string
  ) => {
    return show(!options ? 'info' : options.type, title, message, btnOk, btnCancel, size, helpRoute);
  };

  const error = (
    header?: string,
    message?: string,
    btnOk?: string,
    btnCancel?: string,
    size?: string,
    helpRoute?: string
  ) => {
    return show('error', header, message, btnOk, btnCancel, size, helpRoute);
  };

  const confirmation = (
    header?: string,
    message?: string,
    btnOk?: string,
    btnCancel?: string,
    size?: string,
    helpRoute?: string
  ) => {
    return show('confirm', header, message, btnOk, btnCancel, size, helpRoute);
  };

  const closeAllModals = async () => {
    await dxModal.close();
  };

  return {
    information,
    warning,
    custom,
    error,
    confirmation,
    closeAllModals
  };
};
